<!-- src/components/static/BarChart.vue -->
<template>
    <div class="bar-chart-wrapper">
      <apexchart
        :key="chartKey"
        type="bar"
        height="320"
        :options="normalizedOptions"
        :series="normalizedSeries"
      />
    </div>
  </template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'BarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    chartData: {
      type: Array,
      required: true
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    normalizedSeries () {
      if (!Array.isArray(this.chartData)) return []

      const categories = this.normalizedOptions.xaxis && Array.isArray(this.normalizedOptions.xaxis.categories)
        ? this.normalizedOptions.xaxis.categories
        : []
      const palette = Array.isArray(this.normalizedOptions.colors)
        ? this.normalizedOptions.colors
        : []

      return this.chartData.map(series => {
        const seriesData = Array.isArray(series.data) ? series.data : []
        return {
          ...series,
          data: seriesData.map((value, index) => {
            const numericValue = Number(String(value).replace(',', '.'))
            const safeValue = Number.isFinite(numericValue) ? numericValue : 0

            return {
              x: categories[index] || String(index + 1),
              y: safeValue,
              fillColor: palette[index] || palette[0] || '#808080'
            }
          })
        }
      })
    },
    normalizedOptions () {
      return {
        ...this.chartOptions,
        chart: {
          ...(this.chartOptions.chart || {}),
          type: 'bar'
        },
        plotOptions: {
          ...(this.chartOptions.plotOptions || {}),
          bar: {
            ...((this.chartOptions.plotOptions && this.chartOptions.plotOptions.bar) || {}),
            distributed: true
          }
        }
      }
    },
    chartKey () {
      return JSON.stringify({
        categories: this.normalizedOptions.xaxis && this.normalizedOptions.xaxis.categories
          ? this.normalizedOptions.xaxis.categories
          : [],
        series: this.normalizedSeries
      })
    }
  }
}
</script>

<style scoped>
.bar-chart-wrapper {
  width: 100%;
  min-height: 320px;
}
</style>
